import { Trans } from 'react-i18next';

import { invoicePanelTranslationKeys } from '../../translations';

import { StyledInfo } from './Info.styled';

type YourUrlInfoProps = {
   readonly url: string;
};

export const YourUrlInfo = (props: YourUrlInfoProps): JSX.Element => {
   return (
      <StyledInfo testId={'yourUrl'} whiteSpaces={'break-spaces'}>
         <Trans
            i18nKey={invoicePanelTranslationKeys.yourUrl}
            values={{ url: props.url }}
            components={{ bold: <strong /> }}
         />
      </StyledInfo>
   );
};
